import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';


export interface Language {
  id?: string;
  displayName?:string;
  icon?: string;
}


@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public uploadPercent: number = 0;
  public selectedLang: string = "fr";
  public listLang: Array<Language> = [{ id: 'fr', displayName:'Français', icon: '' }, { id: 'de', displayName:'Deutsch',icon: '' }, { id: 'en',displayName:'English', icon: '' }, { id: 'it',displayName:'Italiano', icon: '' }]

  public uploadPercentObserver: any = new BehaviorSubject<number>(this.uploadPercent)
  public allUploadPercentObserver: any = new Subject<any>();

  constructor() { }


  getSelectedLang() {
    return this.selectedLang;
  }

  setSelectedLang(id) {
    this.listLang.forEach(item => {
      if (item.id == id){
        this.selectedLang = id;
        //console.log('selectedLang changed!');
        
      } 
        
    })


  }


}
